module.exports = __webpack_public_path__ + "img/chevron-left.578604d5.svg";